import React, { memo } from 'react'
import { Outlet, Navigate } from 'react-router-dom';
import { isAdmin } from './common/authentification-functions';

type Props = {}

const AdminGuard: React.FC<Props> = memo((props: Props) => {
    if(!isAdmin()){
        return <Navigate to="/login" replace/>
    }
    
    return (
        <Outlet />
    )
})

export default AdminGuard